/** 앱 WebView에서 iOS PHPicker 등으로 갤러리 이미지 로드가 실패했을 때 안내 */
export const FLUTTER_GALLERY_ERROR_MESSAGE =
  '사진을 불러오지 못했습니다. iCloud에만 있는 사진은 기기에 내려받은 뒤 다시 시도하거나 다른 사진을 선택해 주세요'
